module.exports = __webpack_public_path__ + "static/media/valor1.def6ecef.png";